import { Address, zeroAddress } from 'viem'
import { arbitrum, avalanche, base, polygon } from 'viem/chains'

type Deployments = {
  [chainId: number]: {
    [address: Address]: {
      ConfigBuilder: Address
      Messenger: Address
      EscrowDeployer: Address
      DefaultEscrow: Address
      PhuturePool: Address
    }
  }
}

export const deployments: Deployments = {
  [arbitrum.id]: {
    ['0x8e991e9edc300a538ce72186f5bcbc94f4bb9c80']: {
      //ARTXAI
      ConfigBuilder: '0x13fdB807648AAA2161dCC52b2D6fe30659547CC2',
      Messenger: '0x50e6f76E4B97cE6131aeF3959cCF99CE235BE226',
      EscrowDeployer: '0x77777a629a580083d562b98a284f9f5bf7907f6b',
      DefaultEscrow: '0x59575c265dee9feafa4af55ffaeb252def3ab9aa',
      PhuturePool: zeroAddress,
    },
  },
  [base.id]: {
    ['0x83190636c344cf1220ffcbfc0c1198f7867b3667']: {
      //JMX
      ConfigBuilder: zeroAddress,
      Messenger: zeroAddress,
      EscrowDeployer: zeroAddress,
      DefaultEscrow: zeroAddress,
      PhuturePool: zeroAddress,
    },
  },
}

type Messengers = {
  [address: Address]: {
    [chainId: number]: {
      Messenger: Address
      Vault: Address
    }
  }
}

export const additionalRemoteContracts: Messengers = {
  ['0x8e991e9edc300a538ce72186f5bcbc94f4bb9c80']: {
    // ARTXAI
    [avalanche.id]: {
      Messenger: zeroAddress,
      Vault: zeroAddress,
    },
    [polygon.id]: {
      Messenger: zeroAddress,
      Vault: zeroAddress,
    },
  },
}
